
export namespace OBCallingResultDetailConst {
  export const A2S3FunctionConfigs = [
    {
      code: "CA",
      name: "Calendar"
    }
  ]
}